import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {simpleListHeader_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/simpleListHeader_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterSingleDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template";


declare var ko: any;

export class speedTestInsightsLog_template extends vnTemplate {

    protected statusFilter : multipleSelector_template;
    protected searchField  : filterSimple_template;

    protected pagination: pagination_template;
    protected headers: simpleListHeader_template;

    readonly statuses = [

        {"id": "0", "name": "Success"},
        {"id": "1", "name": "Error"},
    ];

    protected getTemplateHtml(): string {

        return  `

                
                <div class="sub-header">
                    <div class="w-justify">
                        <div class="w-left">
                            ${ this.statusFilter.getHtmlBuild() }
                        </div>
                    </div>
                </div>   
                
                 <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                       <div id="selected-statuses"></div>
                    </div>   
                </div>
                
                <div class="list-header w-justify margin-top">
                
                    <div class="w-left">
                        <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Back</button>
                    </div>
                    <div class="w-center">
                        ${ this.searchField.getHtmlBuild() }
                    </div>
                    <div class="w-right">
                        ${ this.pagination.getHtmlBuild() }
                    </div>
                </div>
                
                <div class="w-list-results transaction-int-list"  id="list-results">
                    <table class="list-results">
                        
                        <thead>
                            ` + this.headers.getHtmlBuild()  + `
                        </thead>                    
                        <tbody data-bind="foreach: logData">        
                            <tr>
                                <td class=""><span data-bind="text: date"></span></td>
                                <td class=""><span data-bind="text: domainName"></span></td>
                                <td class=""><span data-bind="text: url"></span></td>
                                <td class=""><span data-bind="text: (isError == 1) ? 'Error' : 'Success'"></span></td>
                                <td class=""><span data-bind="text: message"></span></td>
                            </tr>                 
                        <tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                </div>
            `;
    }

    protected initPartial(): void {

        this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setLabel("Status");
        this.statusFilter.setFilterContainerClass('margin-neg');
        this.statusFilter.setTagContainerId('selected-statuses');
        this.statusFilter.setTagContainerCaption('Selected statuses:');

        this.searchField = new filterSimple_template("searchField",this.getTemplateViewModel(),this.caller);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        let headers = [
            {headerName: "date", fieldName: "date", subHeaders: []},
            {headerName: "Domain", fieldName: "domainName", subHeaders: []},
            {headerName: "url", fieldName: "url", subHeaders: []},
            {headerName: "Status", fieldName: "isError", subHeaders: []},
            {headerName: "Message", fieldName: "message", subHeaders: []},
        ];
        this.headers = new simpleListHeader_template("listHeader", this.getTemplateViewModel(), this.caller, headers);
        this.headers.getTemplateViewModel().orderBy("date");
        this.headers.getTemplateViewModel().orderByDirection("DESC");
        this.headers.getTemplateViewModel().orderByAndDirection("date_DESC");
    }

    protected getTemplateName(): string {

        return "speedTestInsightsLog_template";
    }

    public resetPageNumber(): void {

        this.pagination.getTemplateViewModel().pageNumber(1);
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the view model data/ functions
        let me = this;
        return {
            logData: ko.observableArray([]),
            onClickCancel: function(data, event){

                me.onClickCancel();
            }
        };
    }

    public getViewModelForRequest() {

        return {
            pagination: this.getTemplateViewModel().pagination,
            headers: this.headers.getViewModelForRequest(),
            filter: {
                isError: this.getTemplateViewModel().statusFilter.selectedItems,
                keyword: this.getTemplateViewModel().searchField.filterKeyword(),
            }
        }
    }

    public setLogs(logData) {

        this.getTemplateViewModel().logData(logData);
    }

    public setPaginationTotalCount(totalCount: number):  void {

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    public setStatusFilterItems(){

        this.statusFilter.setItems(this.statuses);
    }

    public onClickCancel(): void{

        this.caller.cancel();
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/speedTestInsightsLog_template.ts